/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, May 30th 2022, 12:22:04 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { Organization } from "lib/schemas";
import { URLS } from "core/routes";
import { useNavigate } from "react-router";
import { useLocalSaveLoggedInUser } from "authentication/hooks/useLocalSaveLoggedInUser";
import { useOnboardingContext } from "onboarding/providers/OnboardingProvider";
import { useGlobalScope } from "core/providers";

export const useRedirectToSetup = (isInvitationAcceptanceSuccessful: boolean, organization: Organization) => {
  // Storing the LoggedInUser
  const { fetchUserDetails, loggedInUser, isFetchingUserDetails, httpResponseStatusCode, isAPIError } =
    useLocalSaveLoggedInUser();

  React.useEffect(() => {
    if (isInvitationAcceptanceSuccessful) fetchUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInvitationAcceptanceSuccessful]);

  const navigate = useNavigate();

  const { updateGlobalOrganizationScope } = useGlobalScope();

  const { setOnboardingState } = useOnboardingContext();

  React.useEffect(() => {
    if (loggedInUser) {
      updateGlobalOrganizationScope({ selectedOrganization: organization });
      setOnboardingState((prev) => ({ ...prev, onboardingStep: 0 }));
      navigate(URLS.setup);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInUser, organization]);

  return { isFetchingUserDetails, httpResponseStatusCode, isAPIError };
};
